import { j as o } from "./jsx-runtime-721af1ab.js";
import { CloseIcon as c } from "@chakra-ui/icons";
import { VStack as a, Flex as l, Text as n, Spacer as m, IconButton as x, Box as d, Image as p } from "@chakra-ui/react";
import { F as j } from "./FileSaver.min-1b3caba2.js";
import "react";
import "./lodash-3345fe65.js";
const S = ({
  document: t,
  setPreviewDocument: i
}) => {
  const e = t, s = () => {
    try {
      fetch(e.SignedUrl, { method: "GET" }).then((r) => r.blob()).then((r) => {
        j.saveAs(r, e.Filename);
      });
    } catch (r) {
      console.error(`Error downloading file: ${r}`);
    }
  };
  return /* @__PURE__ */ o.jsxs(a, { my: 5, children: [
    /* @__PURE__ */ o.jsxs(l, { w: "100%", children: [
      /* @__PURE__ */ o.jsx(n, { children: "View Document" }),
      /* @__PURE__ */ o.jsx(m, {}),
      /* @__PURE__ */ o.jsx(
        x,
        {
          size: "xs",
          colorScheme: "gray",
          "aria-label": "Close preview",
          icon: /* @__PURE__ */ o.jsx(c, {}),
          onClick: () => i(void 0)
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx(n, { cursor: "pointer", textDecoration: "underline", onClick: () => s(), children: `Download file: ${e == null ? void 0 : e.DocumentDescription}` }),
    e.Filename.includes("pdf") && // NOTE: might need to add security headers for 'object' tags or use iframe
    /* @__PURE__ */ o.jsx(d, { as: "object", w: "100%", h: "700px", data: e == null ? void 0 : e.SignedUrl }),
    e.Filename.includes("jpg") && /* @__PURE__ */ o.jsx(p, { maxW: "100%", maxH: "700px", src: e == null ? void 0 : e.SignedUrl, alt: "document image" })
  ] });
};
export {
  S as ViewDocument
};
